import { useEffect } from 'react';
import { trackEvent } from '../lib/analytics';

export function ScrollDepthTracker() {
  useEffect(() => {
    let fired = false;
    const path = window.location.pathname;

    function onScroll() {
      if (fired) return;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (documentHeight <= 0) return;
      const depth = Math.round((window.scrollY / documentHeight) * 100);
      if (depth >= 50) {
        fired = true;
        trackEvent({ event: 'scroll_depth', location: 'page', label: '50_percent', value: path, routeFamily: path.split('/')[1] || 'home' });
        window.removeEventListener('scroll', onScroll);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return null;
}
